import stat from '../../utils/stat';
import { createElement } from './PluginCustomProgress';
import intl from 'react-intl-universal';

const PluginStat = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function() {
        this.el = null;
        this.player = null;
        this.dom = null;
      },
      createEl: function(el: any, player: any) {
        this.el = el;
        this.player = player;

        //<div class="prism-big-play-btn center" id="player_afsn12fd_component_B7F1C9AD-FD6E-408D-8868-4BDC70034B3D" style="display: block;"><div class="outter"></div></div>
        this.dom = createElement('div', {
          className: 'custom-live-play prism-play-btn',
          style: 'float: left; margin-left: 15px; margin-top: 12px;'
        });

        this.dom.innerText = intl.get('VIDEO_LIVE');

        this.dom.addEventListener('click', () => {
          if (
            this.dom.className &&
            this.dom.className.indexOf('playing') > -1
          ) {
            this.player.pause();
          } else {
            this.player.play();
          }
        });

        let controlBar = this.el.querySelector('.prism-controlbar');
        controlBar.appendChild(this.dom);
      },
      play: function(player: any) {
        this.dom.className = 'custom-live-play prism-play-btn playing';
        console.log('liveplay play');
      },
      pause: function(player: any) {
        this.dom.className = 'custom-live-play prism-play-btn';
        console.log('liveplay pause');
      }
    })
  : null;

export default PluginStat;
